export const CLUBS_LINK = '/clubs';
